import "./Css/app.css";
import "./Css/Snapshots.css";
import "./Css/PreviewBox.css";
import "./Css/QualitySelector.css";
import "./Css/LoginPage.scss";
import "./Css/ReceiverPage.css";
import "./Css/LaunchingInfo.css";
import "./Css/window.css";
import "./Css/snack.css";
import "./Css/TooltipLabel.css";
import "./Css/menu.css";
import "./Css/ocr.css";

HandlersCollection.MANY_HANDLERS_LIMIT = 4;
HandlersCollection.MANY_HANDLERS_WARNING = true;


import { Root, HashRef, ModalWindow, DestroyingPatternContentSwitcher, Select, TextInput, NumberInput, HandlersCollection } from '@tblabs/truffle';
import { LoginPage } from './Pages/Login/LoginPage';
import { LoginLogic } from './Logic/LoginLogic';
import { ReceiverPage } from './Pages/Receiver/ReceiverPage';
import { Server } from './Services/Server';
import { DemoServer } from './Services/DemoServer';
import { Watcher } from './Services/Watcher';
import { DemoWatcher } from './Services/DemoWatcher';
import { Camera } from './Services/Camera/Camera';
import { OnlineStorage } from "./Services/OnlineStorage";
import { DemoOnlineStorage } from "./Services/DemoOnlineStorage";
import { DefaultPage } from './Pages/DefaultPage';
import { SnapsOnlineStorage } from './Services/Storage/SnapsOnlineStorage';
import { Translations } from './Translations/Translations';
import { AppConfigProvider } from './Services/AppConfigProvider';
import { AppSettings } from './Services/AppSettings';
import { Status } from './Services/Status/Status';
import { Notifier } from './Services/Status/Notifier';
import { ReceiverLogic } from './Logic/ReceiverLogic';
import { SnapStorage } from './Services/Storage/SnapStorage';
import { PhotoStorage } from './Services/Storage/PhotoStorage';
import { CameraPictureControl } from './Services/Camera/Control/CameraPictureControl';
import { PresetsProvider } from "./Services/Camera/Control/PresetsProvider";
import { PresetsStorage } from "./Services/Camera/Control/PresetsStorage";
import { DemoCamera } from './Services/Camera/DemoCamera';
import { IoLogic } from './Io/IoLogic';
import { Beepers } from "./Services/Beepers";
import { Auth } from './Services/Auth/Auth';
import { RemoteOcr } from './Services/Ocr/RemoteOcr';
import { DemoOcr } from "./Services/Ocr/DemoOcr";
import { ClientInfoProvider } from "./Services/Storage/ClientInfoProvider";


ModalWindow.DefaultCssClasses = "tf-modal-window";
Select.DefaultCssClasses = "uk-select";
TextInput.DefaultCssClasses = "uk-input";
NumberInput.DefaultCssClasses = "uk-input";


const hash = new HashRef();
const root = new Root("body", "root");

const _lang = new Translations("PL");
const _settings = new AppSettings();
const _watcherIdProvider = new ClientInfoProvider();

const loginPage = ({ server, password }) =>
{
    const _config = new AppConfigProvider(server, password);
    const _auth = new Auth(_config, _lang, _watcherIdProvider);
    const _logic = new LoginLogic(_auth, hash, _lang, _config);

    return new LoginPage(_logic, _lang, _config);
}

const receiverPage = ({ server, password, adminToken }) =>
{
    const _config = new AppConfigProvider(server, password, adminToken);
    const _beepers = new Beepers(_settings);
    const _status = new Status(_lang, _beepers);
    const _server = new Server(_config, _watcherIdProvider);
    const _watcher = new Watcher(_server, _lang, _status);
    const _camera = new Camera(_server);
    const _onlineStorage = new OnlineStorage();
    const _snapsOnlineStorage = new SnapsOnlineStorage(_onlineStorage, _watcherIdProvider, _config.Password);
    const _photoStorage = new PhotoStorage(_config.Password);
    const _ocr = new RemoteOcr(_config);
    const _snapStorage = new SnapStorage(_photoStorage, _snapsOnlineStorage, _ocr);
    const _presetsStorage = new PresetsStorage(_lang);
    const _presetsProvider = new PresetsProvider(_presetsStorage);
    const _pictureControl = new CameraPictureControl(_presetsProvider);
    const _ioLogic = new IoLogic(_camera, _status, _beepers);
    const _logic = new ReceiverLogic(_server, _camera, _snapStorage, _pictureControl, _status, _beepers);

    return new ReceiverPage(_server, _watcher, _camera, _logic, _status, _snapStorage, _lang, _ioLogic, _settings, _beepers);
}

const demoPage = () =>
{
    const password = "demo";
    const _beepers = new Beepers(_settings);
    const _status = new Status(_lang, _beepers);
    const _server = new DemoServer();
    const _watcher = new DemoWatcher(_server, _lang, _status);
    const _camera = new DemoCamera();
    const _onlineStorage = new DemoOnlineStorage();
    const _snapsOnlineStorage = new SnapsOnlineStorage(_onlineStorage, _watcherIdProvider, password);
    const _photoStorage = new PhotoStorage(password);
    const _ocr = new DemoOcr();
    const _snapStorage = new SnapStorage(_photoStorage, _snapsOnlineStorage, _ocr);
    const _presetsStorage = new PresetsStorage(_lang);
    const _presetsProvider = new PresetsProvider(_presetsStorage);
    const _pictureControl = new CameraPictureControl(_presetsProvider);
    const _ioLogic = new IoLogic(_camera, _status, _beepers);
    const _logic = new ReceiverLogic(_server, _camera, _snapStorage, _pictureControl, _status, _beepers);

    return new ReceiverPage(_server, _watcher, _camera, _logic, _status, _snapStorage, _lang, _ioLogic, _settings, _beepers);
}


root.Append(
    new DestroyingPatternContentSwitcher(hash).Class("page-switcher")
        .AddContent("login/:server/:password", loginPage)
        .AddContent("login/:server", loginPage)
        .AddContent("login", loginPage)
        .AddContent("watch/H1/demo", () => demoPage()) // due to old links spread across the internet
        .AddContent("watch/demo", () => demoPage())
        .AddContent("demo", () => demoPage())
        .AddContent("watch/:server/:password/:adminToken", receiverPage)
        .AddContent("watch/:server/:password", receiverPage)
        .AddDefaultContent(() => new DefaultPage(_lang))
        .Refresh(),
)

